import { render, staticRenderFns } from "./OrderStep.vue?vue&type=template&id=794d6024&scoped=true&"
import script from "./OrderStep.vue?vue&type=script&lang=ts&"
export * from "./OrderStep.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStep.vue?vue&type=style&index=0&id=794d6024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794d6024",
  null
  
)

export default component.exports